import { CurrencyData } from '../api/types'

export const mapCurrency = ({
  data,
}: {
  data: CurrencyData[]
}): { list: CurrencyData[]; total: number } => {
  return { list: data, total: data.length }
}
